import request from "@/utils/request";
import { SERVERPATH } from "@/config";

// 开机设置
export function SystemSysOpenInfo(data) {
  return request({
    url: `${SERVERPATH}/system/sysOpenInfo`,
    method: "post",
    data,
  });
}

// 开机图片编辑
export function SystemSysOpenEdit(data) {
  return request({
    url: `${SERVERPATH}/system/sysOpenEdit`,
    method: "post",
    data,
  });
}

// 轮播图列表
export function SystemBannerList(data) {
  return request({
    url: `${SERVERPATH}/system/bannerList`,
    method: "post",
    data,
  });
}

// 轮播图详情
export function SystemBannerInfo(data) {
  return request({
    url: `${SERVERPATH}/system/bannerInfo`,
    method: "post",
    data,
  });
}

// 轮播图新增
export function SystemBannerAdd(data) {
  return request({
    url: `${SERVERPATH}/system/bannerAdd`,
    method: "post",
    data,
  });
}

// 轮播图编辑
export function SystemBannerEdit(data) {
  return request({
    url: `${SERVERPATH}/system/bannerEdit`,
    method: "post",
    data,
  });
}

// 轮播图删除
export function SystemBannerDel(data) {
  return request({
    url: `${SERVERPATH}/system/bannerDel`,
    method: "post",
    data,
  });
}

// HS CODE列表
export function SystemHsCodeList(data) {
  return request({
    url: `${SERVERPATH}/system/hsCodeList`,
    method: "post",
    data,
  });
}

// HS CODE详情
export function SystemHsCodeInfo(data) {
  return request({
    url: `${SERVERPATH}/system/hsCodeInfo`,
    method: "post",
    data,
  });
}

// HS CODE新增
export function SystemHsCodeAdd(data) {
  return request({
    url: `${SERVERPATH}/system/hsCodeAdd`,
    method: "post",
    data,
  });
}

// HS CODE修改
export function SystemHsCodeEdit(data) {
  return request({
    url: `${SERVERPATH}/system/hsCodeEdit`,
    method: "post",
    data,
  });
}

// HS CODE删除
export function SystemHsCodeDel(data) {
  return request({
    url: `${SERVERPATH}/system/hsCodeDel`,
    method: "post",
    data,
  });
}

// 其他设置
export function SystemOtherSettingInfo(data) {
  return request({
    url: `${SERVERPATH}/system/otherSettingInfo`,
    method: "post",
    data,
  });
}

// 财务设置
export function SystemFinanceSettingInfo(data) {
  return request({
    url: `${SERVERPATH}/system/financeSettingInfo`,
    method: "post",
    data,
  });
}

// 管理员设置
export function SystemAdminSettingInfo(data) {
  return request({
    url: `${SERVERPATH}/system/adminSettingInfo`,
    method: "post",
    data,
  });
}

// 设置编辑保存
export function SystemSettingEdit(data) {
  return request({
    url: `${SERVERPATH}/system/settingEdit`,
    method: "post",
    data,
  });
}

// 物流设置
export function SystemLogicSettingInfo(data) {
  return request({
    url: `${SERVERPATH}/system/logicSettingInfo`,
    method: "post",
    data,
  });
}

// 提示语设置
export function SystemPromptInfo(data) {
  return request({
    url: `${SERVERPATH}/system/promptInfo`,
    method: "post",
    data,
  });
}

// 提示语设置保存
export function SystemPromptInfoEdit(data) {
  return request({
    url: `${SERVERPATH}/system/promptInfoEdit`,
    method: "post",
    data,
  });
}

// 合同设置
export function SystemContractInfo(data) {
  return request({
    url: `${SERVERPATH}/system/contractInfo`,
    method: "post",
    data,
  });
}

// 颜色列表
export function SystemBaseColorList(data) {
  return request({
    url: `${SERVERPATH}/system/baseColorList`,
    method: "post",
    data,
  });
}

// 颜色详情
export function SystemBaseColorInfo(data) {
  return request({
    url: `${SERVERPATH}/system/baseColorInfo`,
    method: "post",
    data,
  });
}

// 颜色新增
export function SystemBaseColorAdd(data) {
  return request({
    url: `${SERVERPATH}/system/baseColorAdd`,
    method: "post",
    data,
  });
}

// 颜色编辑
export function SystemBaseColorEdit(data) {
  return request({
    url: `${SERVERPATH}/system/baseColorEdit`,
    method: "post",
    data,
  });
}

// 颜色删除
export function SystemBaseColorDel(data) {
  return request({
    url: `${SERVERPATH}/system/baseColorDel`,
    method: "post",
    data,
  });
}
